import { createHttpClient } from "./http";

export class UnidadeDistribuidorRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async save(formData) {
		try {
			const result = await this.axios.post("unidade-distribuidor", formData, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "multipart/form-data",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar unidade distribuidora.");
		}
	}

	async update(formData) {
		try {
			const result = await this.axios.patch("unidade-distribuidor", formData, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "multipart/form-data",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao atualizar unidade distribuidora.");
		}
	}

	async getAll(page = 1, limit = 10, search = "") {
		try {
			const params = { page, limit };
			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("unidade-distribuidor", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar unidades distribuidoras.");
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`unidade-distribuidor/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			if(error.response?.status === 404)
				throw new Error("Unidade distribuidora não encontrada.");

			throw new Error(error.message || "Erro ao carregar unidade distribuidora.");
		}
	}

	async delete(id) {
		try {
			const result = await this.axios.delete(`unidade-distribuidor/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error("Erro ao excluir unidade distribuidora.");
		}
	}

	async changeVisibility(id) {
		try {
			const result = await this.axios.put(`unidade-distribuidor/visibility/${id}`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error("Erro ao alterar visibilidade da unidade distribuidora.");
		}
	}

	async getByEmpresaDistribuidor(empresaDistribuidorId) {
		try {
			const result = await this.axios.get(`unidade-distribuidor/empresa/${empresaDistribuidorId}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar unidades distribuidoras da empresa.");
		}
	}
}
